/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import withLocationManager from '../shared_components/hoc_location_manager';
import Immutable from 'immutable';
import PropTypes from '../util/prop_types';
import { MapSelectors } from '../stores/map_selectors';
import { MapActionCreators } from '../stores/map_action_creators';
import Popup from './popup';

const mapStateToProps = (state) => {
  return {
    viewport: MapSelectors.getViewport(state),
    popupData: MapSelectors.getPopup(state),
  }
}

const mapDispatchToProps = {
  clearPopup:  MapActionCreators.clearPopup,
};

class MapPopup extends React.PureComponent {
  static propTypes = {
    viewport: PropTypes.immutable.map,
    popupData: PropTypes.immutable.map,
    pushLocation: PropTypes.func.isRequired,
  }

  static contextTypes = {
    map: PropTypes.object,
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.popupData.isEmpty() && nextProps.popupData != this.props.popupData) {
      const feature = nextProps.popupData.get('feature');
      if (feature.id) {
        nextProps.pushLocation({placeId:feature.id});
      }
    }
  }

  _onClose = () => {
    this.props.pushLocation({placeId:false});
    this.props.clearPopup();
  }

  _renderContent = (): ?React.Element<any> => {
    const feature = this.props.popupData.get('feature');
    const template = (feature.id && typeof feature.id === 'string' && feature.id.indexOf('-') != -1)
      ? feature.id.split('-', 1)[0] : null;
    const props = feature.properties;

    switch (template) {
      case "prk": {
        return (
          <div className="infopanel">
            <h2>Lot {props.old_name}</h2>
            <div className="infopanel-additional">
              {props.descr &&
                <p>{props.descr}</p>
              }
              {props.zone_color &&
                <span><strong>Zone:</strong> {props.zone_color}</span>
              }
            </div>
          </div>
        )
      }
      case "dining": {
        return (
          <div className="infopanel">
            <h2>{props.name}</h2>
            <div className="infopanel-additional">
              {props.url &&
                <a href={props.url} target="_blank">More Information</a>
              }
            </div>
          </div>
        )
      }
      case "bldg": {
        let title = (props.ref_en) ? props.ref_en + " - " + props.name : props.name;

        let links = [];
        if (props.additional_info && props.additional_info.links) {
          for(var label in props.additional_info.links) {
            let link = props.additional_info.links[label];
            links.push(
              <li key={link} >
                <a href={link} target="_blank">{label}</a>
              </li>
            );
          }
        }

        return (
          <div className="infopanel">
            <h2>{title}</h2>
            {props.additional_info &&
              <div className="infopanel-additional">
                {props.additional_info.img &&
                  <img src={props.additional_info.img} />
                }
                {props.additional_info.body}
                {links &&
                  <ul>
                    {links}
                  </ul>
                }
              </div>
            }
          </div>
        );
      }
      default: {
        let title = (props.ref_en) ? props.ref_en + " - " + props.name : props.name;

        return (
          <div className="infopanel">
            <h2>{title}</h2>
          </div>
        );
      }
    }
  }

  render(): ?React.Element<any> {
    const { popupData } = this.props;

    return (
      <div>
        {!popupData.isEmpty() &&
          <Popup
            longitude={popupData.get('longitude')}
            latitude={popupData.get('latitude')}
            onClose={this._onClose}>
            {this._renderContent()}
          </Popup>
        }
      </div>
    );
  }
}

export default withLocationManager(connect(mapStateToProps, mapDispatchToProps)(MapPopup));
